export default 'settingsAdvancedSyslog';
